import { Region } from 'constants/shop';
import { getHandle } from './get-handle';
import { COLLECTION_HANDLES, CollectionHandleKey } from '../handles';

const KEYS = Object.keys(COLLECTION_HANDLES) as Array<CollectionHandleKey>;

// Inverse of getHandle: only the handle this region actually serves matches,
// so a handle of another region can never shadow the current one.
export const createCollectionHandleKeyMap = (
  handle: string,
  region: Region = Region.DE
): CollectionHandleKey | undefined => {
  if (!handle) {
    return undefined;
  }

  return KEYS.find((key) => {
    return getHandle({ key, region }) === handle;
  });
};
